import { render, staticRenderFns } from "./MediumAdd.vue?vue&type=template&id=2ae07040"
import script from "./MediumAdd.vue?vue&type=script&lang=js"
export * from "./MediumAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports